module.exports = __webpack_public_path__ + "img/cartao-de-credito.28c0f529.svg";